<style lang="scss" scoped>
@import "./scss/Public.scss";
</style>

<template>
  <div class="profit-box">
    <div class="title-box">
      <h3>{{accountSettingLan.title}}</h3>
    </div>
    <div class="panel" v-loading="loading" element-loading-spinner="el-icon-loading">
      <profit-table
        v-if="trData"
        :thData="thData"
        :trData="trData"
        :page="page"
        :selPage="selPage"
        :operate="operate"
        :curArea="curArea"
        :name="name"
        :multiLanguage="accountSettingLan"
        :jsonExcelAjax="jsonExcelAjax"
        :downLoadTran="downLoadTran"
        @tableChange="requestHandle"
      >
        <div slot="handle" class="conditions">
          <div class="condition">
            <span>{{accountSettingLan.status_text}}</span>
            <el-select v-model="is_selected" style="width: 95px;" @change="changeHandle">
              <el-option
                v-for="(key,val) in accountSettingLan.status_mapper"
                :key="val"
                :label="key"
                :value="val"
              ></el-option>
            </el-select>
          </div>
          <div class="condition change-el-input-group-style">
            <el-input v-model="searchVal">
              <el-select v-model="searchKey" slot="prepend" style="width: 105px;">
                <el-option
                  v-for="(item, index) in accountSettingLan.selectArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-button slot="append" @click="requestHandle">{{accountSettingLan.search}}</el-button>
            </el-input>
          </div>
          <div class="condition">
            <el-button-group>
              <el-button type="primary" @click="calculateHandle">{{accountSettingLan.calculate}}</el-button>
              <el-button type="primary" @click="addAccount">{{accountSettingLan.addUser}}</el-button>
            </el-button-group>
          </div>
          <el-dialog
            :title="accountSettingLan.add_title"
            :close-on-click-modal="false"
            :visible.sync="visible"
          >
            <el-form
              :model="account"
              label-position="top"
              :rules="accountSettingLan.rules"
              ref="account"
            >
              <el-form-item>
                <el-col :span="11">
                  <el-form-item :label="accountSettingLan.login" prop="login">
                    <el-input v-model="account.login"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2">&nbsp;</el-col>
                <el-col :span="11">
                  <el-form-item :label="accountSettingLan.ib_account" prop="ib">
                    <el-input v-model="account.ib"></el-input>
                  </el-form-item>
                </el-col>
              </el-form-item>
              <el-form-item>
                <el-col :span="11">
                  <el-form-item :label="accountSettingLan.percentage" prop="percentage">
                    <el-input v-model="account.percentage"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2">&nbsp;</el-col>
                <el-col :span="11">
                  <el-form-item :label="accountSettingLan.app_date" prop="date">
                    <el-date-picker
                      type="date"
                      :placeholder="accountSettingLan.date_placeholder"
                      v-model="account.date"
                      style="width: 100%;"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="cancelSubmit">{{accountSettingLan.cancel}}</el-button>
              <el-button type="primary" @click="addAccountHandle">{{accountSettingLan.ensure}}</el-button>
            </div>
          </el-dialog>
        </div>
        <div slot="title-name" class="extraSearch">
          <div class="moreSelect">
            <el-switch v-model="more" :active-text="accountSettingLan.moreSelect" inactive-text></el-switch>
          </div>
          <div class="searchDiv" v-show="more">
            <span>{{accountSettingLan.deposit}}</span>
            <el-select v-model="filter.deposit" style="width: 95px;" @change="changeHandle">
              <el-option
                v-for="(key,val) in accountSettingLan.enable_mapping"
                :key="val"
                :label="key"
                :value="val"
              ></el-option>
            </el-select>
          </div>
          <div class="searchDiv" v-show="more">
            <span>{{accountSettingLan.withdrawal}}</span>
            <el-select v-model="filter.withdrawal" style="width: 95px;" @change="changeHandle">
              <el-option
                v-for="(key,val) in accountSettingLan.enable_mapping"
                :key="val"
                :label="key"
                :value="val"
              ></el-option>
            </el-select>
          </div>
          <div class="searchDiv" v-show="more">
            <span>{{accountSettingLan.transfer}}</span>
            <el-select v-model="filter.transfer" style="width: 95px;" @change="changeHandle">
              <el-option
                v-for="(key,val) in accountSettingLan.enable_mapping"
                :key="val"
                :label="key"
                :value="val"
              ></el-option>
            </el-select>
          </div>
        </div>
      </profit-table>
    </div>
  </div>
</template>

<script>
import { updateTimeByUtc, getTimeDiff } from "common/js/util";
import ProfitTable from "./ProfitTable";
import {
  URL_ACCOUNT_SETTING,
  URL_UPDATE_SETTING,
  URL_BEGIN_CALCULATE,
  URL_ADD_ACCOUNT
} from "api/commissionApi";
let data = () => {
  return {
    loading: true,
    trData: [],
    is_selected: "0",
    searchVal: "",
    searchKey: "LOGIN",
    visible: false,
    more: false,
    filter: {
      deposit: "ALL",
      withdrawal: "ALL",
      transfer: "ALL"
    },
    account: {
      login: "",
      ib: "",
      percentage: "",
      date: ""
    },
    page: {
      active: 1,
      pageLeng: 0
    },
    selPage: {
      list: [5, 10, 25, 50],
      active: localStorage.pageMaxIndex,
      limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
    },
    operate: {
      btnGroup: true,
      updateVal: { do: 1, undo: 0, three: 2 },
      showKey: {
        1: ["IS_DELETED", "0"],
        0: ["IS_DELETED", "1"],
        2: ["IS_DELETED", "0"]
      },
      url: URL_UPDATE_SETTING,
      updateKey: {
        "0": "IS_DELETED",
        "1": "IS_DELETED",
        backup: "NEXT_CALC_DATE"
      }
    }
  };
};

const mounted = function() {
  this.requestHandle();
};

const methods = {
  addAccount() {
    this.visible = true;
  },
  addAccountHandle() {
    this.$refs.account.validate(valid => {
      if (valid) {
        let accountInfo = {
          area: this.curArea,
          account: this.account
        };
        accountInfo.account.update_by = JSON.parse(
          sessionStorage.getItem("user")
        ).user_name;
        accountInfo.account.date = this.$moment(this.account.date).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.$http.post(URL_ADD_ACCOUNT, accountInfo).then(res => {
          const result = res.data.data;
          this.visible = false;
          this.$refs.account.resetFields();
          const message = this.accountSettingLan.code_mapping[result];
          const type = this.accountSettingLan.message_type[result];
          this.$message({ message: message, type: type });
          if (type == "success") this.requestHandle();
        });
      }
    });
  },
  cancelSubmit() {
    this.visible = false;
    this.$refs.account.resetFields();
  },
  changeHandle() {
    this.page.active = 1;
    this.requestHandle();
  },
  requestHandle() {
    try {
      let obj = {
        params: {
          status: this.is_selected,
          searchKey: this.searchKey,
          searchVal: this.searchVal,
          area: this.curArea,
          pageNum: this.page.active - 1,
          pageSize: this.selPage.limit,
          filter: this.filter
        }
      };
      this.$http.get(URL_ACCOUNT_SETTING, obj).then(res => {
        this.trData = res.data.data.rows;
        this.page.pageLeng = res.data.data.count;
        this.loading = false;
        this.trData.forEach(t => {
          const mapping = this.accountSettingLan.enable_mapping;
          t.deposit = t.DEPOSIT ? mapping[t.DEPOSIT] : "";
          t.withdrawal = t.WITHDRAWAL ? mapping[t.WITHDRAWAL] : "";
          t.fundtransfer = t.FUNDTRANSFER ? mapping[t.FUNDTRANSFER] : "";
          t.is_negative_before = this.accountSettingLan.result_mapper[
            t.IS_NEGATIVE_BEFORE
          ];
          t.is_deleted = this.accountSettingLan.status_mapper[t.IS_DELETED];
          t.LAST_UPDATE = updateTimeByUtc(getTimeDiff(), t.LAST_UPDATE);
          t.checked = false;
        });
      });
    } catch (error) {
      this.loading = false
    }
  },
  calculateHandle() {
    if (window.confirm(this.accountSettingLan.confirm)) {
      this.$http.post(URL_BEGIN_CALCULATE, { area: this.curArea }).then(res => {
        const result = res.data.data;
        if (result == "SUCCESS") {
          this.$message({
            message: this.accountSettingLan.calculateDone,
            type: "success"
          });
          this.requestHandle();
        } else
          this.$message({
            message: this.accountSettingLan.noNeedCal,
            type: "warning"
          });
      });
    }
  }
};

const props = {
  curArea: {
    type: String,
    required: true
  }
};

const mixins = [
  require("common/mixin/base.js").base({ accountSettingLan: "accountSetting" })
];

const computed = {
  thData() {
    return this.accountSettingLan.first_row;
  },
  jsonExcelAjax() {
    return {
      url: URL_ACCOUNT_SETTING,
      ajaxType: "get",
      getKey: ["data", "data", "rows"],
      ajaxPar: {
        pageSize: this.page.pageLeng,
        pageNum: 0,
        status: this.is_selected,
        searchKey: this.searchKey,
        searchVal: this.searchVal,
        area: this.curArea,
        filter: this.filter
      }
    };
  },
  downLoadTran() {
    const language = this.accountSettingLan;
    return {
      IS_DELETED: language.status_mapper,
      IS_NEGATIVE_BEFORE: language.result_mapper,
      DEPOSIT: language.enable_mapping,
      WITHDRAWAL: language.enable_mapping,
      FUNDTRANSFER: language.enable_mapping
    };
  },
  name() {
    return this.accountSettingLan.title;
  }
};

const watch = {
  curArea() {
    this.page.active = 1;
    this.searchKey = "LOGIN";
    this.searchVal = "";
    this.is_selected = "0";
    this.more = false;
    this.loading = true;
    Object.keys(this.filter).forEach(v => (this.filter[v] = "ALL"));
    this.requestHandle();
  },
  accountSettingLan(newVal, oldVal) {
    this.trData.forEach(t => {
      const mapping = this.accountSettingLan.enable_mapping;
      t.deposit = t.DEPOSIT ? mapping[t.DEPOSIT] : "";
      t.withdrawal = t.WITHDRAWAL ? mapping[t.WITHDRAWAL] : "";
      t.fundtransfer = t.FUNDTRANSFER ? mapping[t.FUNDTRANSFER] : "";
      t.is_negative_before = newVal.result_mapper[t.IS_NEGATIVE_BEFORE];
      t.is_deleted = newVal.status_mapper[t.IS_DELETED];
    });
  }
};

const components = { ProfitTable };

export default {
  data,
  mounted,
  methods,
  props,
  mixins,
  computed,
  watch,
  components
};
</script>



// WEBPACK FOOTER //
// AccountSetting.vue?0b28133b